// TEMP_BRIDGE
module.exports = require("./MainCard" + ".tsx");

